(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hero-video-sound-toggle"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__heroVideoSoundInit) return;
    window.__heroVideoSoundInit = true;

    document.addEventListener('click', function (event) {
      var button = event.target.closest('.hero__sound-toggle');
      if (!button) return;

      var hero = button.closest('.hero');
      if (!hero) return;

      // aria-pressed reflects the current state: 'true' means sound is on.
      var turnSoundOn = button.getAttribute('aria-pressed') !== 'true';
      var videos = hero.querySelectorAll('video');

      videos.forEach(function (video) {
        // offsetParent is null when the element (or an ancestor) is display:none,
        // so only the visible desktop/mobile variant gets unmuted.
        var isVisible = video.offsetParent !== null;

        if (turnSoundOn && isVisible) {
          video.muted = false;
          var playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(function () {});
          }
        } else {
          video.muted = true;
        }
      });

      button.setAttribute('aria-pressed', turnSoundOn ? 'true' : 'false');
      var nextLabel = turnSoundOn ? button.dataset.labelMute : button.dataset.labelUnmute;
      if (nextLabel) button.setAttribute('aria-label', nextLabel);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
